var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLiving = function SvgLiving(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.5,
    d: "M30 70V45.333c0-1.866 0-2.8.364-3.513.32-.627.83-1.137 1.456-1.457C32.533 40 33.467 40 35.334 40h9.333c1.867 0 2.8 0 3.513.363.627.32 1.137.83 1.457 1.457.363.713.363 1.647.363 3.513V70M6.667 31.667 36.8 9.067c1.148-.861 1.722-1.291 2.352-1.457a3.33 3.33 0 0 1 1.697 0c.63.166 1.204.596 2.351 1.457l30.134 22.6m-60-5v32.666c0 3.734 0 5.6.726 7.027a6.67 6.67 0 0 0 2.914 2.913C18.4 70 20.267 70 24 70h32c3.734 0 5.6 0 7.027-.727a6.67 6.67 0 0 0 2.913-2.913c.727-1.426.727-3.293.727-7.027V26.667L46.4 11.467c-2.295-1.722-3.442-2.582-4.703-2.914a6.67 6.67 0 0 0-3.394 0c-1.26.332-2.408 1.192-4.703 2.914z"
  })));
};
export default SvgLiving;